<template>
  <li class="price-row" :class="type">
    <slot name="label">
      <span class="label"> {{ label }} </span>
    </slot>
    <slot name="calculation">
      <span class="calculation" v-if="calculation"> {{ calculation }} </span>
    </slot>
    <slot name="price">
      <span class="price" v-if="price !== undefined"> {{ formattedPrice }}</span>
    </slot>
  </li>
</template>

<script>
export default {
  props: {
    // Type can be: 'positive', 'highlight', 'bold', bold-subtle',
    type: String,
    label: String,
    calculation: String,
    price: Number,
    format: {
      type: String,
      default: 'short',
    },
  },
  computed: {
    formattedPrice() {
      if (this.format === 'long') {
        return this.toCurrencyLongEur(this.price);
      }

      return this.toCurrencyEur(this.price);
    },
  },
};
</script>

<style lang="scss" scoped>
@use 'assets/scss/_helpers/display';
@use 'assets/scss/_variables/colors';

.price-row {
  display: grid;
  grid-template-areas:
    'label price'
    'calculation price';
  align-items: center;
  .label {
    grid-area: label;
  }
  .calculation {
    grid-area: calculation;
    color: colors.$text-subtle;
  }
  .price {
    grid-area: price;
    justify-self: end;
    margin-left: 8px;
  }
  .calculation + .price {
    align-self: end;
  }
}
</style>
